import { render, staticRenderFns } from "./CaseSideBar.vue?vue&type=template&id=3ca79d98&scoped=true&"
import script from "./CaseSideBar.vue?vue&type=script&lang=ts&"
export * from "./CaseSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./CaseSideBar.vue?vue&type=style&index=0&id=3ca79d98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca79d98",
  null
  
)

export default component.exports